import React from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

interface ContentWrapperComProps {
  children: React.ReactNode;
}

const ContentWrapperCom: React.FC<ContentWrapperComProps> = ({ children }) => {
  return (
    <Content style={{ padding: '0 50px', minHeight: 'calc(100vh - 134px)' }}>
      <div style={{ background: '#fff', padding: '24px', minHeight: '100%' }}>
        {children}
      </div>
    </Content>
  );
};

export default ContentWrapperCom;
